export const LEGACY_ACCOUNT_TAG_ALIASES = {
  IVA_RETENIDO: 'IVA_RETENIDO_CREDITO',
  TARJETA_CORPORATIVA: 'TARJETA_CREDITO',
};

export const ACCOUNT_SYSTEM_TAGS = [
  { key: 'AFC_POR_PAGAR', label: 'AFC por Pagar', defaultStandardKey: '' },
  { key: 'AFP_POR_PAGAR', label: 'AFP por Pagar', defaultStandardKey: '2.08.02.01' },
  { key: 'AGUINALDOS_POR_PAGAR', label: 'Aguinaldos por Pagar', defaultStandardKey: '' },
  {
    key: 'ANTICIPO_SUELDOS_POR_PAGAR',
    label: 'Anticipo de Sueldos por Pagar',
    defaultStandardKey: '1.12.02.02',
  },
  { key: 'CAJA', label: 'Caja', defaultStandardKey: '1.01.01.01' },
  { key: 'ABONOS_POR_TERCERO', label: 'Abonos por Tercero', defaultStandardKey: '' },
  { key: 'CLIENTES', label: 'Clientes por Cobrar', defaultStandardKey: '1.05.01.01' },
  { key: 'FACTORING_POR_COBRAR', label: 'Factoring por Cobrar', defaultStandardKey: '' },
  { key: 'INCOBRABLE', label: 'Incobrable', defaultStandardKey: '' },
  {
    key: 'CAJA_COMPENSACION_POR_PAGAR',
    label: 'Caja de Compensación por Pagar',
    defaultStandardKey: '2.08.04.01',
  },
  { key: 'CLIENTES_BOLETAS', label: 'Clientes por Cobrar Boletas', defaultStandardKey: '' },
  { key: 'DOCUMENTOS_POR_COBRAR', label: 'Documentos por Cobrar', defaultStandardKey: '1.06.01.01' },
  { key: 'FINIQUITOS_POR_PAGAR', label: 'Finiquitos por Pagar', defaultStandardKey: '' },
  { key: 'GASTOS_POR_ADELANTADO', label: 'Gastos por Adelantado', defaultStandardKey: '' },
  { key: 'HONORARIOS_POR_PAGAR', label: 'Honorario por Pagar', defaultStandardKey: '2.03.02.01' },
  {
    key: 'IMPUESTO_2DA_CATEGORIA_POR_PAGAR',
    label: 'Impuesto 2ª Categoría por Pagar',
    defaultStandardKey: '2.07.01.01',
  },
  {
    key: 'IMPUESTO_ADICIONAL_3_PCT_PRESTAMO_SOLIDARIO',
    label: 'Impuesto adicional 3% préstamo solidario',
    defaultStandardKey: '',
  },
  { key: 'INGRESO_POR_ADELANTADO', label: 'Ingreso por Adelantado', defaultStandardKey: '2.10.01.02' },
  {
    key: 'INGRESOS_PENDIENTES_FACTURAR',
    label: 'Ingresos Pendientes de Facturar',
    defaultStandardKey: '2.11.01.01',
  },
  { key: 'ISAPRE_POR_PAGAR', label: 'Isapre por Pagar', defaultStandardKey: '2.08.01.01' },
  { key: 'IVA_DEBITO', label: 'IVA Débito', defaultStandardKey: '2.06.02.01' },
  { key: 'IVA_CREDITO', label: 'IVA Crédito', defaultStandardKey: '1.08.02.01' },
  {
    key: 'CORRECCION_MONETARIA_ACTIVOS',
    label: 'Corrección Monetaria Activos',
    defaultStandardKey: '4.04.01.01',
  },
  { key: 'IVA_RETENIDO_CREDITO', label: 'IVA Retenido Crédito', defaultStandardKey: '' },
  { key: 'IVA_RETENIDO_DEBITO', label: 'IVA Retenido Débito', defaultStandardKey: '' },
  { key: 'IVA_NO_RECUPERABLE', label: 'IVA no Recuperable', defaultStandardKey: '3.15.02.01' },
  { key: 'IVA_POSTPONE', label: 'IVA Postergado', defaultStandardKey: '2.06.04.01' },
  { key: 'MUTUALES_POR_PAGAR', label: 'Mutuales por Pagar', defaultStandardKey: '2.08.03.01' },
  { key: 'NOTA_DE_VENTA', label: 'Nota de venta', defaultStandardKey: '' },
  { key: 'OTROS_IMPUESTOS_CREDITO', label: 'Otros Impuestos Crédito', defaultStandardKey: '' },
  {
    key: 'OTROS_IMPUESTOS_COMBUSTIBLE',
    label: 'Otros Impuestos Combustible',
    defaultStandardKey: '',
  },
  { key: 'OTROS_IMPUESTOS_DEBITO', label: 'Otros Impuestos Débito', defaultStandardKey: '' },
  {
    key: 'OTROS_IMPUESTOS_POR_PAGAR',
    label: 'Otros Impuestos por Pagar',
    defaultStandardKey: '',
  },
  {
    key: 'OTROS_DESCUENTOS_POR_PAGAR',
    label: 'Otros Descuentos por Pagar',
    defaultStandardKey: '1.06.03.02',
  },
  {
    key: 'PROVEEDORES_INTERNACIONALES',
    label: 'Proveedor internacionales',
    defaultStandardKey: '2.04.01.02',
  },
  { key: 'PROVEEDORES', label: 'Proveedores por Pagar', defaultStandardKey: '2.04.01.01' },
  { key: 'PROVEEDORES_BOLETAS', label: 'Proveedores por Pagar Boletas', defaultStandardKey: '' },
  { key: 'PPM', label: 'PPM', defaultStandardKey: '1.08.01.01' },
  { key: 'PPM_POR_PAGAR', label: 'PPM por Pagar', defaultStandardKey: '2.06.01.01' },
  {
    key: 'RETIROS_SOCIOS',
    label: 'Retiros Socios',
    defaultStandardKey: '1.13.01.01',
  },
  {
    key: 'REMUNERACIONES_POR_PAGAR',
    label: 'Remuneraciones por Pagar',
    defaultStandardKey: '2.03.01.01',
  },
  {
    key: 'IMPOSICIONES_POR_PAGAR',
    label: 'Imposiciones por Pagar',
    defaultStandardKey: '2.08.05.01',
  },
  {
    key: 'GASTOS_REMUNERACIONES',
    label: 'Remuneraciones de Personal',
    defaultStandardKey: '3.01.01.01',
  },
  {
    key: 'APORTE_PATRONAL',
    label: 'Aportes Patronales',
    defaultStandardKey: '3.01.03.01',
  },
  {
    key: 'RETENCION_BH',
    label: 'Retención Boleta Honorarios por Pagar',
    defaultStandardKey: '2.07.02.01',
  },
  { key: 'TARJETA_CREDITO', label: 'Tarjeta de Crédito', defaultStandardKey: '2.01.01.03' },
  {
    key: 'PAGOS_TARJETA_CREDITO_CUOTAS',
    label: 'Pagos Tarjeta de Crédito por Cuotas',
    defaultStandardKey: '',
  },
  { key: 'SEGURO_SOCIAL', label: 'Seguro Social', defaultStandardKey: '' },
  { key: 'ILA', label: 'ILA (Imp. Licores/Alcoholes)', defaultStandardKey: '' },
  { key: 'INGRESOS_POR_BOLETA', label: 'Ingresos por Boleta', defaultStandardKey: '' },
  { key: 'INGRESOS', label: 'Ingresos', defaultStandardKey: '4.01.01.01' },
  { key: 'GASTOS_HONORARIOS', label: 'Gastos Honorarios', defaultStandardKey: '3.02.01.01' },
  { key: 'GASTOS_DEFAULT', label: 'Gastos (fallback)', defaultStandardKey: '3.16.01.01' },
];

const DEFAULT_KEY_BY_TAG = ACCOUNT_SYSTEM_TAGS.reduce((acc, tag) => {
  if (tag.defaultStandardKey) {
    acc[tag.key] = tag.defaultStandardKey;
  }
  return acc;
}, {});

const LEGACY_KEYS_BY_CANONICAL = Object.entries(LEGACY_ACCOUNT_TAG_ALIASES).reduce((acc, [legacy, canonical]) => {
  if (!acc[canonical]) acc[canonical] = [];
  acc[canonical].push(legacy);
  return acc;
}, {});

const LABEL_BY_TAG = ACCOUNT_SYSTEM_TAGS.reduce((acc, tag) => {
  acc[tag.key] = tag.label;
  return acc;
}, {});

export const resolveSystemAccountTag = (tag) => LEGACY_ACCOUNT_TAG_ALIASES[tag] ?? tag;

export const getTagLookupKeys = (tag) => {
  const canonical = resolveSystemAccountTag(tag);
  const legacy = LEGACY_KEYS_BY_CANONICAL[canonical] ?? [];
  return [...new Set([tag, canonical, ...legacy])];
};

export const getDefaultStandardKeyForTag = (tag) => {
  const canonical = resolveSystemAccountTag(tag);
  return DEFAULT_KEY_BY_TAG[canonical] ?? DEFAULT_KEY_BY_TAG[tag];
};

export const getSystemTagLabel = (tag) => {
  const canonical = resolveSystemAccountTag(tag);
  return LABEL_BY_TAG[canonical] || LABEL_BY_TAG[tag] || tag;
};

export const getAccountByKey = (accountKey, accounts) => {
  if (!accountKey || !accounts?.length) return null;

  const searchRecursive = (items) => {
    for (const item of items) {
      if (item.key === accountKey) return item;
      if (item.children?.length) {
        const found = searchRecursive(item.children);
        if (found) return found;
      }
    }
    return null;
  };

  return searchRecursive(accounts);
};

export const getAccountByTag = (tag, accounts) => {
  if (!tag || !accounts?.length) return null;
  const lookupKeys = new Set(getTagLookupKeys(tag));

  const searchRecursive = (items) => {
    for (const item of items) {
      if (item.accountTag && lookupKeys.has(item.accountTag)) return item;
      if (item.children?.length) {
        const found = searchRecursive(item.children);
        if (found) return found;
      }
    }
    return null;
  };

  return searchRecursive(accounts);
};

export const getCompanyAccountByTag = (tag, accounts) => {
  const tagged = getAccountByTag(tag, accounts);
  if (tagged) return tagged;

  const standardKey = getDefaultStandardKeyForTag(tag);
  if (!standardKey) return null;
  return getAccountByKey(standardKey, accounts);
};

export const buildAccountTagAssignments = (accounts, tagOptions = ACCOUNT_SYSTEM_TAGS) => {
  const assignments = tagOptions.map((tag) => {
    const account = getAccountByTag(tag.key, accounts);
    return {
      tagKey: tag.key,
      tagLabel: tag.label,
      accountKey: account?.key || null,
      accountName: account?.name || null,
      assigned: Boolean(account),
    };
  });
  return assignments;
};

export const buildAccountNodeUpdateInput = (account, overrides = {}) => {
  const category = account?.category || {};
  const payload = {
    key: account.key,
    label: account.label || `${account.key} ${account.name}`,
    name: account.name,
    category: {
      key: category.key ?? '',
      label: category.label ?? '',
      name: category.name ?? '',
    },
  };

  if (Object.prototype.hasOwnProperty.call(overrides, 'accountTag')) {
    const tag = overrides.accountTag?.trim();
    payload.accountTag = tag || '';
  }

  return payload;
};

export const buildTagAssignmentUpdates = (accounts, tagKey, newAccountKey) => {
  if (!tagKey || !accounts?.length) return [];

  const currentTagged = getAccountByTag(tagKey, accounts);
  const nextKey = newAccountKey?.trim() || '';

  if (currentTagged?.key === nextKey) return [];

  const updates = [];

  if (currentTagged && currentTagged.key !== nextKey) {
    updates.push(buildAccountNodeUpdateInput(currentTagged, { accountTag: '' }));
  }

  if (nextKey) {
    const target = getAccountByKey(nextKey, accounts);
    if (target) {
      updates.push(buildAccountNodeUpdateInput(target, { accountTag: tagKey }));
    }
  }

  return updates;
};
